import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import api from "../lib/api";

// Manages the recycle-bin view: loading trashed captures, selection,
// restore, and permanent-delete actions (single + bulk).
export function useTrash({ loadTags, loadCaptures, selectedTagId }) {
  const { t } = useTranslation();
  const [trashCaptures, setTrashCaptures] = useState([]);
  const [trashSelectedIds, setTrashSelectedIds] = useState([]);

  const loadTrash = async () => {
    const { data } = await api.get("/captures/trash");
    setTrashCaptures(data);
    setTrashSelectedIds([]);
  };

  const toggleTrashSelect = (id) => {
    setTrashSelectedIds((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  };

  const handleRestore = async (id) => {
    await api.post(`/captures/${id}/restore`);
    setTrashCaptures((prev) => prev.filter((c) => c.id !== id));
    setTrashSelectedIds((prev) => prev.filter((x) => x !== id));
    loadCaptures(selectedTagId);
    loadTags();
    toast.success(t("trash.restoredOne"));
  };

  const handleBulkRestore = async () => {
    await api.post("/captures/bulk-restore", { capture_ids: trashSelectedIds });
    setTrashCaptures((prev) => prev.filter((c) => !trashSelectedIds.includes(c.id)));
    setTrashSelectedIds([]);
    loadCaptures(selectedTagId);
    loadTags();
    toast.success(t("trash.restoredMany"));
  };

  const handlePermanentDelete = async (id) => {
    await api.delete(`/captures/${id}/permanent`);
    setTrashCaptures((prev) => prev.filter((c) => c.id !== id));
    setTrashSelectedIds((prev) => prev.filter((x) => x !== id));
    toast.success(t("trash.permanentDeletedOne"));
  };

  const handleBulkPermanentDelete = async () => {
    await api.post("/captures/bulk-permanent-delete", { capture_ids: trashSelectedIds });
    setTrashCaptures((prev) => prev.filter((c) => !trashSelectedIds.includes(c.id)));
    setTrashSelectedIds([]);
    toast.success(t("trash.permanentDeletedMany"));
  };

  return {
    trashCaptures, loadTrash, trashSelectedIds, toggleTrashSelect,
    handleRestore, handleBulkRestore, handlePermanentDelete, handleBulkPermanentDelete,
  };
}
